import MuiCheckbox from '@mui/material/Checkbox';

import { styled } from 'helpers';

import { CheckboxProps } from './';

export const Checkbox = styled(MuiCheckbox)<CheckboxProps>`
  color: ${({ theme }) => theme.palette.blueGrey['A400']};
  padding: 0;
  border-radius: 0px;

  &:hover {
    background-color: inherit;
    .MuiSvgIcon-root path {
      color: ${({ theme }) => theme.palette.blueGrey['A600']};
    }
  }

  &.Mui-checked:hover path,
  &.MuiCheckbox-indeterminate:hover path {
    color: ${({ theme }) => theme.palette.blue['900']};
  }

  &.Mui-focusVisible .MuiSvgIcon-root {
    outline: 2px solid ${({ theme }) => theme.palette.lightBlue['400']};
    border-radius: 5px;
    outline-offset: -3px;
  }

  &.Mui-disabled {
    color: ${({ theme }) => theme.palette.blueGrey['A100']};
    cursor: not-allowed;
  }
  &.Mui-disabled::after,
  &:hover::after {
    content: ' ';
    position: absolute;
    background: ${({ theme }) => theme.palette.grey['50']};
    height: 14px;
    width: 14px;
    z-index: -1;
  }
  &.Mui-checked::after,
  &.MuiCheckbox-indeterminate::after {
    background: inherit;
  }
`;

export default Checkbox;
